module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-11.4a7ba774.jpg";